import Image from "next/image";

import classes from "./SearchLoader.module.scss";

/**
 * Animated magnifying glass to display on the map when search is taking too long
 */
export default function SearchLoader() {
  return (
    <div className={classes.searchLoader}>
      <Image src="/images/searching.gif" alt="Searching..." fill unoptimized />
    </div>
  );
}
